import React from 'react';
import { Shield } from 'lucide-react';

export const PaymentBadges = ({ className = '', dark = false }) => {
  return (
    <div className={`${className}`} data-testid="payment-badges">
      <div className="flex items-center justify-center gap-2 mb-4">
        <Shield className="h-5 w-5 text-leafgreen" />
        <span className={`text-sm font-bold uppercase tracking-wide ${dark ? 'text-white' : 'text-charcoal'}`}>Secure Payments</span>
      </div>
      
      <div className="flex flex-wrap items-center justify-center gap-3">
        {/* Stripe */}
        <div className="h-12 px-5 bg-white border-2 border-border hover:border-coral flex items-center justify-center rounded-lg shadow-sm hover:shadow-md transition-all min-w-[80px]" title="Stripe">
          <span className="font-bold text-lg" style={{color: '#635BFF', fontFamily: 'sans-serif'}}>stripe</span>
        </div>

        {/* PayPal */}
        <div className="h-12 px-5 bg-white border-2 border-border hover:border-denim flex items-center justify-center rounded-lg shadow-sm hover:shadow-md transition-all min-w-[80px]" title="PayPal">
          <span className="font-bold text-lg" style={{color: '#003087', fontFamily: 'sans-serif'}}>PayPal</span>
        </div>

        {/* Visa */}
        <div className="h-12 px-5 bg-white border-2 border-border hover:border-mustard flex items-center justify-center rounded-lg shadow-sm hover:shadow-md transition-all min-w-[70px]" title="Visa">
          <span className="font-black text-xl tracking-tight" style={{color: '#1A1F71', fontFamily: 'Arial, sans-serif', fontStyle: 'italic'}}>VISA</span>
        </div>

        {/* Mastercard */}
        <div className="h-12 px-5 bg-white border-2 border-border hover:border-coral flex items-center justify-center rounded-lg shadow-sm hover:shadow-md transition-all min-w-[70px]" title="Mastercard">
          <div className="flex items-center gap-0.5">
            <div className="w-6 h-6 rounded-full" style={{backgroundColor: '#EB001B'}}></div>
            <div className="w-6 h-6 rounded-full -ml-3" style={{backgroundColor: '#FF5F00'}}></div>
          </div>
        </div>

        {/* American Express */}
        <div className="h-12 px-5 bg-white border-2 border-border hover:border-denim flex items-center justify-center rounded-lg shadow-sm hover:shadow-md transition-all min-w-[70px]" title="American Express">
          <div className="px-3 py-1 rounded" style={{backgroundColor: '#006FCF'}}>
            <span className="text-white font-black text-sm tracking-tight">AMEX</span>
          </div>
        </div>

        {/* Apple Pay */}
        <div className="h-12 px-5 bg-white border-2 border-border hover:border-charcoal flex items-center justify-center rounded-lg shadow-sm hover:shadow-md transition-all min-w-[80px]" title="Apple Pay">
          <div className="flex items-center gap-1">
            <div className="text-black text-2xl font-bold" style={{fontFamily: '-apple-system, BlinkMacSystemFont, sans-serif'}}>
              
            </div>
            <span className="font-medium text-base text-black">Pay</span>
          </div>
        </div>

        {/* Google Pay */}
        <div className="h-12 px-5 bg-white border-2 border-border hover:border-leafgreen flex items-center justify-center rounded-lg shadow-sm hover:shadow-md transition-all min-w-[80px]" title="Google Pay">
          <div className="flex items-center gap-1">
            <span className="font-bold text-2xl" style={{color: '#4285F4'}}>G</span>
            <span className="font-medium text-base text-charcoal">Pay</span>
          </div>
        </div>

        {/* Discover */}
        <div className="h-12 px-5 bg-white border-2 border-border hover:border-burntorange flex items-center justify-center rounded-lg shadow-sm hover:shadow-md transition-all min-w-[90px]" title="Discover">
          <div className="px-3 py-1 rounded" style={{backgroundColor: '#FF6000'}}>
            <span className="text-white font-black text-xs tracking-wide">DISCOVER</span>
          </div>
        </div>
      </div>

      <p className={`text-center text-xs mt-4 ${dark ? 'text-white/50' : 'text-softgrey'}`}>
        All transactions are secure and encrypted • SSL Protected
      </p>
    </div>
  );
};
